export default __webpack_public_path__ + "static/media/Trushil-Budhia-Resume.8828e85b.pdf";